import { useQuery } from "@tanstack/react-query";

import { IUser } from "../../models/User/User";
import { CustomerUsersQueryKeys } from "./keys";
import useApiHelper from "../../hooks/useApiHelper";
import { IDefaultResponse } from "../../models/DefaultResponse";

export default function useCustomerUsers(customerId: string) {
  const { get } = useApiHelper();

  const customerUsers = useQuery({
    queryKey: CustomerUsersQueryKeys.all(customerId),
    queryFn: () =>
      get<IDefaultResponse<IUser[]>>(`/customer/${customerId}/users`).then(
        (res) => res.data,
      ),
    enabled: !!customerId,
  });

  return {
    customerUsers,
  };
}
